<div class="mute-dialog" id="MuteAlertDialog">
    <div class="mute-dialog-header">
        <div class="mute-dialog-title">{{ isNetworkOnly ? 'Mute every alert in this network' : 'Mute alerts' }}</div>
        <div class="mute-dialog-subtitle">
            A mute stops the notifications. It does not stop the alert: the problem is still watched, the alert is still
            recorded, and can still resolve on its own.
        </div>
    </div>

    <!-- Opened from the header there is nothing to narrow to, so the scope question is
         not asked. The summary at the foot still says in words what will be silenced. -->
    @if (!isNetworkOnly) {
    <div class="mute-dialog-section">
        <div class="mute-dialog-label">What to mute</div>
        <button
            type="button"
            class="mute-option"
            id="MuteScopeAlert"
            [ngClass]="{ selected: scope === 'ALERT', disabled: !canScopeToAlert }"
            [disabled]="!canScopeToAlert"
            (click)="setScope('ALERT')"
        >
            <span class="mute-option-title">Just this alert</span>
            <span class="mute-option-detail">Only this alert, matched on every detail it reports.</span>
        </button>
        <!-- With no labels there is nothing to pin, and a request with no matchers is a
             network-wide mute by type. Offering it as "just this alert" would silence far
             more than the reader asked for. -->
        @if (!canScopeToAlert) {
        <div class="mute-dialog-note" id="MuteNoLabelsNote">
            This alert reports no details to match on, so it cannot be muted on its own.
        </div>
        }
        <button
            type="button"
            class="mute-option"
            id="MuteScopeType"
            [ngClass]="{ selected: scope === 'TYPE' }"
            (click)="setScope('TYPE')"
        >
            <span class="mute-option-title">Every {{ typeLabel }} alert</span>
            <span class="mute-option-detail"
                >Across this whole network, including alerts that have not happened yet.</span
            >
        </button>
        <button
            type="button"
            class="mute-option"
            id="MuteScopeNetwork"
            [ngClass]="{ selected: scope === 'NETWORK' }"
            (click)="setScope('NETWORK')"
        >
            <span class="mute-option-title">Everything in this network</span>
            <span class="mute-option-detail">Every alert of every type. Nothing on this network notifies anybody.</span>
        </button>
        <!-- The widest thing the dialog can do, so it says so in words rather than
             leaving the reader to work it out from the option label. -->
        @if (isNetworkWide) {
        <div class="mute-dialog-note mute-dialog-warn" id="MuteNetworkWideNote">
            This stops every notification on the network, including alerts with nothing to do with this one. Keep it
            short, and revoke it when the work that called for it is done.
        </div>
        }
    </div>
    } @else {
    <div class="mute-dialog-note mute-dialog-warn" id="MuteNetworkOnlyNote">
        This stops every notification on the network, of every alert type, including alerts that have not happened yet.
        Keep it short, and revoke it when the work that called for it is done.
    </div>
    }

    <div class="mute-dialog-section">
        <div class="mute-dialog-label">For how long</div>
        <div class="mute-duration-row">
            @for (duration of durations; track duration.label; let i = $index) {
            <button
                type="button"
                class="mute-chip"
                id="MuteDuration{{ i }}"
                [ngClass]="{ selected: durationIndex === i }"
                (click)="setDuration(i)"
            >
                {{ duration.label }}
            </button>
            }
        </div>
        @if (isIndefinite) {
        <div class="mute-dialog-note mute-dialog-warn" id="MuteIndefiniteNote">
            A mute with no end date stays in place after the problem is fixed. Nothing will end it and nothing will
            remind you it is there — somebody has to revoke it by hand.
        </div>
        }
    </div>

    <div class="mute-dialog-section">
        <div class="mute-dialog-label">Reason <span class="mute-dialog-optional">optional</span></div>
        <!-- Worth writing, but never a gate: this text is what the console shows against
             every alert the mute covers, and it is the answer when somebody asks later
             why nobody was paged. A mute during an incident still goes out without it. -->
        <textarea
            class="mute-reason"
            id="MuteReason"
            rows="2"
            maxlength="500"
            placeholder="e.g. known bad transceiver, replacement scheduled"
            [(ngModel)]="reason"
        ></textarea>
    </div>

    <div class="mute-dialog-summary" id="MuteSummary">
        <span class="mute-dialog-summary-label">This will silence</span>
        <span>{{ scopeSummary }}</span>
    </div>

    <div class="mute-dialog-actions">
        <button type="button" class="mute-button mute-button-cancel" id="MuteCancel" (click)="cancel()">Cancel</button>
        <button type="button" class="mute-button" id="MuteConfirm" (click)="confirm()">
            {{ isNetworkOnly ? 'Mute the network' : 'Mute' }}
        </button>
    </div>
</div>
